module.exports = __webpack_public_path__ + "img/move04.91f5d99b.jpg";